import {gameInit} from "../../actions";
import {ActionType} from "typesafe-actions";
import IAnalyticsAction from "../IAnalyticsAction";

export default function gameInitHandler(action: ActionType<typeof gameInit>): IAnalyticsAction | undefined {
    return {
        category: "application",
        name: "start",
   };
}